export interface ProviderDatesQueryParamsInput {
  practice_id: unknown;
  department_id: unknown;
  provider_id: unknown;
  start_date: unknown;
  end_date: unknown;
  care_format: unknown;
  user_uuid?: unknown;
  user_timezone?: unknown;
  speciality?: unknown;
  daysoftheweek?: unknown;
  ageserved?: unknown;
  packageID?: unknown;
  minimum_day_time?: unknown;
  clinician_type?: unknown;
  duration?: unknown;
}

const toRequiredString = (value: unknown): string => {
  if (Array.isArray(value)) {
    return value.join(",");
  }

  return String(value);
};

const toOptionalString = (value: unknown): string | undefined => {
  if (value === undefined || value === null) {
    return undefined;
  }

  if (Array.isArray(value)) {
    return value.join(",");
  }

  const stringValue = String(value);
  return stringValue.trim() ? stringValue : undefined;
};

export const buildProviderDatesUpstreamQueryParams = (
  input: ProviderDatesQueryParamsInput,
): Record<string, string> => {
  const queryParams: Record<string, string> = {
    practice_id: toRequiredString(input.practice_id),
    department_id: toRequiredString(input.department_id),
    provider_id: toRequiredString(input.provider_id),
    start_date: toRequiredString(input.start_date),
    end_date: toRequiredString(input.end_date),
    care_format: toRequiredString(input.care_format),
    user_uuid: String(input.user_uuid ?? ""),
    user_timezone: String(input.user_timezone ?? ""),
  };

  const optionalPairs: Array<[string, unknown]> = [
    ["speciality", input.speciality],
    ["daysoftheweek", input.daysoftheweek],
    ["ageserved", input.ageserved],
    ["packageID", input.packageID],
    ["minimum_day_time", input.minimum_day_time],
    ["clinician_type", input.clinician_type],
    ["duration", input.duration],
  ];

  optionalPairs.forEach(([key, value]) => {
    const stringValue = toOptionalString(value);
    if (stringValue !== undefined) {
      queryParams[key] = stringValue;
    }
  });

  return queryParams;
};
